export default __webpack_public_path__ + "static/media/BPmanagement.96db81ad.svg";